import React, { useState, forwardRef } from 'react';
import { SHOW_QUIZ_FEATURES } from '../config/features';
import './Sidebar.css';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { House, Info, Trash, Cog, LogOut, WalletCards, BookOpen, Search, Star, Folder, Sparkles, TrendingUp } from 'lucide-react';
import PricingModal from './PricingModal';
import SettingsModal from './SettingsModal';


const Sidebar = forwardRef(({ onCollapse, toggleFlashcards, toggleQuiz, isCollapsed, isMobileOpen, onMobileClose, documents = [] }, ref) => {
    console.log('toggleFlashcards', toggleFlashcards);
    console.log('Sidebar received documents:', documents);
    const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
    const [showPricingModal, setShowPricingModal] = useState(false);
    const [showSettingsModal, setShowSettingsModal] = useState(false);
    const [showSearchModal, setShowSearchModal] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredDocuments, setFilteredDocuments] = useState([]);
    const [theme, setTheme] = useState('Light');
    const [showModal, setShowModal] = useState(false)


  const toggleModal = () => { 
    setShowModal(!showModal);
  }

  const handleLogout = () => {
    auth.signOut();
    window.location.href = '/';
  }

  

    const outsideClick = () => {
        if (showSettingsDropdown) {
            setShowSettingsDropdown(false);
        }
    };

    const handleUpgradeClick = () => {
        setShowPricingModal(true);
    };

    const handleClosePricingModal = () => {
        setShowPricingModal(false);
    };

    const handleSettingsClick = () => {
        setShowSettingsModal(true);
        setShowSettingsDropdown(false);
    };

    const handleCloseSettingsModal = () => {
        setShowSettingsModal(false);
    };

    const handleSearchClick = () => {
        setShowSearchModal(true);
    };

    const handleCloseSearchModal = () => {
        setShowSearchModal(false);
        setSearchQuery('');
        setFilteredDocuments([]);
    };

    const handleSearchChange = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        
        if (query.trim() === '') {
            setFilteredDocuments([]);
        } else {
            const filtered = documents.filter(doc => 
                (doc.document_name || doc.name || doc.title || '').toLowerCase().includes(query.toLowerCase())
            );
            setFilteredDocuments(filtered);
        }
    };

    const handleLogOut = () => {
        auth.signOut();
        window.location.href = '/';
    };

    const toggleSettingsDropdown = () => {
        setShowSettingsDropdown(!showSettingsDropdown);
    };

    const toggleCollapse = () => {
        if (onCollapse) {
            onCollapse(!isCollapsed);
        }
    };

    const handleHomeClick = () => {
        window.location.href = `/main/${user.uid}`;
        setShowSearchModal(false);
    };

    const [user, setUser] = useState(null);


    const handleFlashcardsClick = () => {
        setShowSearchModal(false);
        toggleFlashcards();
    };

    const handleMyLibraryClick = () => {
        setShowSearchModal(false);
        window.location.href = `/my-library/${user.uid}`;
    };

    const handleStudyPlanClick = () => {
        setShowSearchModal(false);
        window.location.href = '/study-plan';
    };

    const handleMyFilesClick = () => {
        setShowSearchModal(false);
        window.location.href = `/my-files/${user.uid}`;
    }

    React.useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setUser(user);
        });

        return () => unsubscribe();
    }, []);

    // Handle ESC key to close search modal
    React.useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && showSearchModal) {
                handleCloseSearchModal();
            }
        };

        if (showSearchModal) {
            document.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [showSearchModal]);

    return (
        <>
        {/* Mobile Overlay */}
        {isMobileOpen && (
            <div 
                className="sidebar-overlay active" 
                onClick={onMobileClose}
            />
        )}
        
        <div onClick={outsideClick} className={`sidebar ${isCollapsed ? 'collapsed' : ''} ${isMobileOpen ? 'mobile-open' : ''}`}>
            {/* Mobile Close Button */}
            <button className="mobile-close-btn" onClick={onMobileClose}>
                ×
            </button>
            
            {/* Collapse Button */}
            {/* <button className="collapse-btn" onClick={toggleCollapse}>
                {isCollapsed ? '→' : '←'}
            </button> */}

            {/* User Greeting & Actions */}
            <div className="sidebar-header">
                <div className="user-greeting">
                    {/* <span className={isCollapsed ? 'hidden' : ''}>
                        Hi, {user?.displayName || 'User'}
                    </span> */}
                    {/* <button onClick={toggleFlashcards} className="add-btn">+</button> */}

                    <img src="https://iili.io/KYpg7rg.png" alt="Study-Space Logo" className='sidebar-logo' />
                    {/* <span className={isCollapsed ? 'hidden' : ''}>Study-Space</span> */}
                </div>
                
                {/* Search */}
                {/* <div className={`search-container ${isCollapsed ? 'hidden' : ''}`} onClick={handleSearchClick}>
                    <input 
                        type="text" 
                        placeholder="Search Study Documents" 
                        className="search-input"
                        readOnly
                    />
                    <div className="search-icon"><Search size={12} className='search-icon-icon' /></div>
                </div> */}
            </div>

            {/* Main Navigation */}
            <nav className="main-nav">
                <div onClick={handleHomeClick} className="nav-item active">
                    <div style={{marginTop: '1px'}} className="nav-icon"><House className='nav-icon-icon' /></div>
                    {/* <span className={isCollapsed ? 'hidden' : ''}>Home</span> */}
                </div>
                <div onClick={toggleFlashcards} className="nav-item flash-cards-icon-row">
                    <div style={{marginTop: '2px'}} className="nav-icon"><WalletCards className='nav-icon-icon' /></div>
                    {/* <span className={isCollapsed ? 'hidden' : ''}>Flashcards</span> */}
                </div>
                <div onClick={handleMyLibraryClick} className="nav-item">
                    <div  style={{marginTop: '3px'}} className="nav-icon"><BookOpen className='nav-icon-icon' /></div>
                    {/* <span className={isCollapsed ? 'hidden' : ''}>My Library</span> */}
                </div>
                <div onClick={handleStudyPlanClick} className="nav-item">
                    <div style={{marginTop: '2px'}} className="nav-icon"><TrendingUp className='nav-icon-icon' /></div>
                    {/* <span className={isCollapsed ? 'hidden' : ''}>Study Plan</span> */}
                </div>
                <div onClick={handleMyFilesClick} className="nav-item">
                    <div style={{marginTop: '2px'}} className="nav-icon"><Folder className='nav-icon-icon' /></div>
                    {/* <span className={isCollapsed ? 'hidden' : ''}>My Files</span> */}
                </div>


          
            </nav>

            {/* Your Journals */}
            {/* <div className={`journals-section ${isCollapsed ? 'hidden' : ''}`}>
                <h3 className="section-title">Your Journals</h3>
                <div className="journal-item">
                    <span>New Journal</span>
                </div>
            </div> */}

            {/* Account & Help */}
            <div className="sidebar-footer">
                {/* Mobile Collapse CTA */}
                {/* <div className="mobile-collapse-cta">
                    <button 
                        className="collapse-cta-btn"
                        onClick={onMobileClose}
                    >
                        <span>Collapse</span>
                    </button>
                </div>
                 */}
                {/* <button 
                    className={`upgrade-btn ${isCollapsed ? 'collapsed' : ''}`}
                    onClick={handleUpgradeClick}
                >
                    <div className="upgrade-icon">↗</div>
                    <span className={isCollapsed ? 'hidden' : ''}><Sparkles className='upgrade-icon' size={12} style={{marginTop: '6px', marginRight: '6px'}} />Upgrade</span>
                </button> */}
                
                <div className={`footer-nav ${isCollapsed ? 'hidden' : ''}`}>
                    {/* <div className="footer-nav-item">
                        <div className="footer-nav-icon"><Info className='footer-nav-icon-icon' /></div>
                        <span>Quick Guide</span>
                    </div>
                   */}
                    <div className="footer-nav-item" onClick={toggleSettingsDropdown}>
                        <div className="footer-nav-icon"><Cog className='footer-nav-icon-icon' /></div>
                        {/* <span>Settings</span> */}
                    </div>
                </div>
    
                {/* User Profile */}
                <div onClick={handleSettingsClick} className="user-profile">
                    <div className="user-avatar">
                        {user?.displayName?.charAt(0) || 'U'}
                    </div>
                    <div className={`user-info ${isCollapsed ? 'hidden' : ''}`}>
                        <div className="user-name">
                            {user?.displayName || 'User'}
                        </div>
                        <div className="user-plan">Free</div>
                    </div>
                    {/* <div className={`dropdown-arrow ${isCollapsed ? 'hidden' : ''}`}>⌄</div> */}
                </div>
            </div>
          
        </div>

        {/* Settings Dropdown */}
        {showSettingsDropdown && (
            <div className="settings-dropdown" onClick={outsideClick}>
                {/* Theme Selection */}
                {/* <div className="theme-selector">
                    <button 
                        className={`theme-btn ${theme === 'Light' ? 'active' : ''}`}
                        onClick={() => setTheme('Light')}
                    >
                        Light
                    </button>
                    <button 
                        className={`theme-btn ${theme === 'Dark' ? 'active' : ''}`}
                        onClick={() => setTheme('Dark')}
                    >
                        Dark
                    </button>
                    <button 
                        className={`theme-btn ${theme === 'System' ? 'active' : ''}`}
                        onClick={() => setTheme('System')}
                    >
                        System
                    </button>
                </div> */}

                {/* Menu Items */}
                <div className="sidebar-dropdown-menu">
                    {/* <div className="dropdown-item">
                        <div className="dropdown-icon">⚙️</div>
                        <span>Settings</span>
                    </div> */}
                    {/* <div className="dropdown-item">
                        <div className="dropdown-icon">🎮</div>
                        <span>Join Discord</span>
                    </div> */}
                    {/* <div className="dropdown-item">
                        <div className="dropdown-icon">👤+</div>
                        <span>Refer a Friend</span>
                        <div className="referral-badge">0</div>
                    </div> */}
                    {/* <div className="dropdown-item">
                        <div className="dropdown-icon">👍</div>
                        <span>Send Feedback</span>
                    </div> */}
                    <div className="dropdown-item" onClick={handleSettingsClick}>
                        <div className="dropdown-icon"><Cog className='dropdown-icon-icon' /></div>
                        <span>Settings</span>
                    </div>
                    <div className="dropdown-item" onClick={handleLogOut}>
                        <div className="dropdown-icon"><LogOut className='dropdown-icon-icon' /></div>
                        <span>Log out</span>
                    </div>
                </div>
            </div>
        )}

        {/* Pricing Modal */}
        <PricingModal 
            isOpen={showPricingModal} 
            onClose={handleClosePricingModal} 
        />

        {/* Settings Modal */}
        <SettingsModal 
            isOpen={showSettingsModal} 
            onClose={handleCloseSettingsModal} 
        />

        {/* Search Modal */}
        {showSearchModal && (
            <div className="search-modal-overlay" onClick={handleCloseSearchModal}>
                <div className="search-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="search-modal-header">
                        <div className="search-input-container">
                            <Search size={20} className="search-modal-icon" />
                            <input 
                                type="text" 
                                placeholder="Search your notes, flashcards, documents..."
                                className="search-modal-input"
                                value={searchQuery}
                                onChange={handleSearchChange}
                                autoFocus
                            />
                        </div>
                    </div>

                    <div className="search-modal-content">
                        {!searchQuery.trim() && (
                            <div className="search-section">
                                <h3 className="search-section-title">Quick Actions</h3>
                                <div className="search-actions">
                                    <div className="search-action-item primary">
                                        <div className="search-action-icon">+</div>
                                        <span>
                                            {SHOW_QUIZ_FEATURES
                                                ? 'Drag or drop PDF documents to create notes, quizzes, flashcards, and more...'
                                                : 'Drag or drop PDF documents to create notes, flashcards, and more...'}
                                        </span>
                                    </div>
                                    <div onClick={handleHomeClick} className="search-action-item">
                                        <div className="search-action-icon"><House className='search-action-icon-icon' /></div>
                                        <span>Switch to Home</span>
                                    </div>
                                        <div onClick={handleFlashcardsClick} className="search-action-item">
                                        <div className="search-action-icon"><WalletCards className='search-action-icon-icon' /></div>
                                        <span>Switch to Flashcards</span>
                                    </div>
                                    {/* <div className="search-action-item">
                                        <div className="search-action-icon"><Folder className='search-action-icon-icon' /></div>
                                        <span>Switch to Sources</span>
                                    </div> */}
                                </div>
                            </div>
                        )}

                        <div className="search-section">
                            <h3 className="search-section-title">
                                {searchQuery.trim() ? 'Search Results' : 'Recent Items'}
                            </h3>
                            <div className="search-results">
                                {searchQuery.trim() ? (
                                    // Show search results
                                    filteredDocuments.length > 0 ? (
                                        filteredDocuments.map((document, index) => (
                                            <div key={document.document_id || document.document_name || index} className="search-result-item">
                                                <div className="search-result-icon"><Folder className='search-result-icon-icon' /></div>
                                                <div className="search-result-content">
                                                    <div className="search-result-title">{document.document_name || document.name || document.title || 'Untitled Document'}</div>
                                                    <div className="search-result-meta">
                                                        PDF • {document.upload_date ? new Date(document.upload_date).toLocaleDateString() : 'Recently uploaded'}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="search-result-item">
                                            <div className="search-result-icon"><Folder className='search-result-icon-icon' /></div>
                                            <div className="search-result-content">
                                                <div className="search-result-title">No results found</div>
                                                <div className="search-result-meta">Try a different search term</div>
                                            </div>
                                        </div>
                                    )
                                ) : (
                                    // Show recent items (initial state)
                                    documents.length > 0 ? (
                                        documents.slice(0, 5).map((document, index) => (
                                            <div key={document.document_id || document.document_name || index} className="search-result-item">
                                                <div className="search-result-icon"><Folder className='search-result-icon-icon' /></div>
                                                <div className="search-result-content">
                                                    <div className="search-result-title">{document.document_name || document.name || document.title || 'Untitled Document'}</div>
                                                    <div className="search-result-meta">
                                                        PDF • {document.upload_date ? new Date(document.upload_date).toLocaleDateString() : 'Recently uploaded'}
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <div className="search-result-item">
                                            <div className="search-result-icon"><Folder className='search-result-icon-icon' /></div>
                                            <div className="search-result-content">
                                                <div className="search-result-title">No documents uploaded yet</div>
                                                <div className="search-result-meta">Upload a PDF to get started</div>
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="search-modal-footer">
                        <div className="search-shortcuts">
                            {/* <div className="search-shortcut">
                                <div className="search-shortcut-key">↑↓</div>
                                <span>Navigate</span>
                            </div>
                            <div className="search-shortcut">
                                <div className="search-shortcut-key">↵</div>
                                <span>Select</span>
                            </div> */}
                            <div className="search-shortcut">
                                <div className="search-shortcut-key">ESC</div>
                                <span>Close</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}
        </>
    );
});

export default Sidebar;
